'use client';

import { useSyncExternalStore } from 'react';
import { useQuery } from '@tanstack/react-query';
import type { FeatureFlag } from '@puzzlio/core/featureFlags';
import { userQueryOptions } from '@/app/providers/UserProvider';
import { readCachedFeatureFlags, serverFeatureFlags } from '@/app/lib/feature-flags-cache';

const noSubscription = () => () => {};

/**
 * Whether a feature flag is on for this player. Until /api/me answers, goes by the flags it last reported on
 * this device. This only decides what the page shows; the server checks flagged actions itself.
 */
export function useFeatureFlag(flag: FeatureFlag): boolean {
  const { data } = useQuery(userQueryOptions);
  const cached = useSyncExternalStore(noSubscription, readCachedFeatureFlags, serverFeatureFlags);
  return (data?.features ?? cached)[flag] === true;
}
